import RepositoryFactory from '@/repository/RepositoryFactory';
import { PutGroupWorkplaceRequest, ResponseGroupWorkplace } from '@/model/repository';
const shiftServiceRepositories = RepositoryFactory.shiftService;

/**
 * 園児グループ名一覧の配列を生成
 * groupCategoryNameの重複のない配列
 * @param {*} childGroups
 */
export function getChildGroupCategoryNames(childGroups: ResponseGroupWorkplace[]) {
  if (!childGroups) return [];
  return Array.from(new Set(childGroups.flatMap((childGroup) => childGroup.groupCategoryName)));
}

/**
 * 園児グループを更新
 * @param {string} groupId
 * @param {PutGroupWorkplaceRequest} payload
 */
export async function updateChildGroupWorkplace(groupId: string, payload: PutGroupWorkplaceRequest) {
  const updatedWorkplaceChildGroup = await shiftServiceRepositories.groupWorkplace.update(groupId, payload);
  return updatedWorkplaceChildGroup.data;
}

export default {
  getChildGroupCategoryNames,
  updateChildGroupWorkplace,
};
